<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="container">
        <div class="text-center pt-md-5 px-md-4 pt-3">
          <h1 class="text-center text-pg-blue mb-3 brand-fontcolor">
            {{ $t('Home.BannerTitle') }}
          </h1>
          <p class="page-subheader" v-html="$t('Home.BannerDesc')"></p>
        </div>
         <div class="text-center readytosubmit mb-5">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-sm-12 text-sm-center">
                <h2 class="">{{ $t('Home.ReadytoSubmitTitle') }}</h2>
                <p class="mt-3">
                  {{ $t('Home.ReadytoSubmitDesc') }}
                </p>

                <div class="col-sm-12">
                  <div class="mb-4">
                    <router-link to="/Upload" class="btn btn-link">
                      {{ $t('Home.GetStartedBtn') }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mb-3">
                <small v-html="$t('Home.ParticipatingProductLink')"></small>
              </div>
              <div class="col-sm-12">
                <small v-html="$t('Home.HavingTroubleLink')"></small>
              </div>
            </div>
          </div>
        </div>
        <div class="home-htp">
          <div class="container">
            <h2 class="text-center mb-md-5 mb-4">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.ShopImg')" alt="Shop" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.ShopTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SnapImg')" alt="Snap" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.SnapTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SendImg')" alt="Send" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.SendTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>        
      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
